module.exports = "/_next/static/images/card-virtual-02-6fccdafa0ff36b25eb87d53587366dac.svg";